let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fIHQM")).then(() => parcelRequire('l9n03'));